import { useState, useEffect, useCallback } from 'react';
import { api } from '../services/api';
import type { CrawlProgress } from '../services/types';

export function useCrawlProgress(novelId: string | undefined, enabled: boolean = true) {
  const [progress, setProgress] = useState<CrawlProgress | null>(null);
  const [isPolling, setIsPolling] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchProgress = useCallback(async () => {
    if (!novelId) return;

    try {
      const data = await api.getNovelProgress(novelId);
      setProgress(data);
      setError(null);

      // 如果完成或失敗，停止輪詢
      if (data.status === 'completed' || data.status === 'failed' || data.status === 'paused') {
        setIsPolling(false);
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch progress');
    }
  }, [novelId]);

  useEffect(() => {
    if (!enabled || !novelId) return;

    let mounted = true;
    
    // 初始加載
    // eslint-disable-next-line react-hooks/set-state-in-effect
    fetchProgress().then(() => {
      if (mounted) {
        setIsPolling(true);
      }
    });

    // 輪詢間隔: 3 秒
    const interval = setInterval(() => {
      fetchProgress();
    }, 3000);

    return () => {
      mounted = false;
      clearInterval(interval);
      setIsPolling(false);
    };
  }, [novelId, enabled, fetchProgress]);

  return { progress, isPolling, error, refetch: fetchProgress };
}
